import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function LatestArticles() {
  const latest = [...articles]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="LATEST"
          title="最新爆料"
          desc="按发布时间排序，每条都标注了核实状态与信源层级。"
          action={
            <Link
              to="/category/entertainment"
              className="inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
            >
              从最新一条看起
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}